import React from 'react';
import FilterTag from './FilterTag';

import { Row, Col } from '@app/ui';

type SelectedFiltersTagsProps = {
    selectedFiltersArray: {
        title: string;
        elements: string[];
        isHidden?: boolean;
    }[];
};

const SelectedFiltersTags = ({
    selectedFiltersArray,
}: SelectedFiltersTagsProps) => {
    return (
        <Row
            gutter={16}
            style={{
                width: '100%',
            }}
        >
            <Col md={22} data-test="new-tag-container" className="-p-h-2">
                {selectedFiltersArray.map(
                    ({ title, elements = [], isHidden }, i) => {
                        if (elements.length !== 0)
                            return (
                                <FilterTag
                                    key={i}
                                    title={title}
                                    tagElements={elements}
                                    isHidden={isHidden}
                                />
                            );
                    },
                )}
            </Col>
        </Row>
    );
};

export default SelectedFiltersTags;
